import AddressPage from './address-page';
export type {
  AddressPageProps,
  SecondaryInfoProps,
  StatsProps,
  FeatureFlags,
  ExperimentProps,
  ComplianceProps,
  PropertyAppraisalProps,
  ActiveListing,
} from './address-page.types';

import getAddressPageServerSideProps from './get-server-side-props';
export type {
  AddressPageServerSideProps,
  AddressPageParams,
} from './get-server-side-props';
export { getAddressPageServerSideProps };
export default AddressPage;